import type { HTMLAttributes } from 'react';
import { Link, type LinkProps } from 'react-router';
import { useLegacyAppLink } from '../../contexts/LegacyAppLinkContext';

interface RoccoLinkProps
    extends HTMLAttributes<HTMLAnchorElement>, Pick<LinkProps, 'prefetch'> {
    to: string;
    isNonRemixRoute?: boolean;
    newTab?: boolean;
}

export const RoccoLink = ({
    children,
    to,
    isNonRemixRoute = false,
    prefetch,
    newTab,
    ...props
}: RoccoLinkProps) => {
    const useLegacyLink = useLegacyAppLink();
    if (useLegacyLink || isNonRemixRoute) {
        return (
            <a
                href={to}
                {...props}
                target={newTab ? '_blank' : '_self'}
                rel={newTab ? 'noreferrer' : undefined}
            >
                {children}
            </a>
        );
    }

    return (
        <Link
            to={to}
            prefetch={prefetch}
            {...props}
            target={newTab ? '_blank' : '_self'}
            rel={newTab ? 'noreferrer' : undefined}
        >
            {children}
        </Link>
    );
};
